export const CORES_ISFP_PSFP_POR_FAIXA = {
  ate_1: "#4CAF50",
  de_1_a_5: "#8BC34A",
  de_5_a_10: "#FFC107",
  de_10_a_20: "#FF9800",
  acima_20: "#F44336",
};

export const FAIXAS_ISFP_PSFP = [
  {
    chave: "acima_20",
    label: "ISFP > 20%",
    intervalo: "> 20",
    cor: CORES_ISFP_PSFP_POR_FAIXA.acima_20,
    corSuave: "#fdecea",
    icone: "mdi-emoticon-sad",
    descricao: "Incorpora 2% na componente Q.",
  },
  {
    chave: "de_10_a_20",
    label: "10% < ISFP <= 20%",
    intervalo: "10 a 20",
    cor: CORES_ISFP_PSFP_POR_FAIXA.de_10_a_20,
    corSuave: "#fff3e0",
    icone: "mdi-emoticon-sad",
    descricao: "Incorpora 1% na componente Q.",
  },
  {
    chave: "de_5_a_10",
    label: "5% < ISFP <= 10%",
    intervalo: "5 a 10",
    cor: CORES_ISFP_PSFP_POR_FAIXA.de_5_a_10,
    corSuave: "#fff8e1",
    icone: "mdi-emoticon-neutral",
    descricao: "Incorpora 0,5% na componente Q.",
  },
  {
    chave: "de_1_a_5",
    label: "1% < ISFP <= 5%",
    intervalo: "1 a 5",
    cor: CORES_ISFP_PSFP_POR_FAIXA.de_1_a_5,
    corSuave: "#f1f8e9",
    icone: "mdi-emoticon-happy",
    descricao: "Incorpora 0% na componente Q.",
  },
  {
    chave: "ate_1",
    label: "ISFP <= 1%",
    intervalo: "<= 1",
    cor: CORES_ISFP_PSFP_POR_FAIXA.ate_1,
    corSuave: "#e8f5e9",
    icone: "mdi-emoticon-happy",
    descricao: "Incorpora -1% na componente Q.",
  },
];

export function getFaixaChaveIsfpPsfp(valor) {
  const numero = Number(valor);

  if (!Number.isFinite(numero)) {
    return null;
  }

  if (numero <= 1) return "ate_1";
  if (numero <= 5) return "de_1_a_5";
  if (numero <= 10) return "de_5_a_10";
  if (numero <= 20) return "de_10_a_20";
  return "acima_20";
}

export function getCorIsfpPsfpPorValor(valor, corPadrao = "#000") {
  const faixaChave = getFaixaChaveIsfpPsfp(valor);

  if (!faixaChave) {
    return corPadrao;
  }

  return CORES_ISFP_PSFP_POR_FAIXA[faixaChave] ?? corPadrao;
}

export function getCorIsfpPsfpPorFaixa(faixaChave, corPadrao = "#000") {
  return CORES_ISFP_PSFP_POR_FAIXA[faixaChave] ?? corPadrao;
}
